import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn, FlexRow } from "./common.styles";
import IphoneImage from "../Media/iphone-device.png";
import RemoveRedEye from "@mui/icons-material/RemoveRedEye";
import { LightSmallText, LightText } from "./HXDesktopPage.styles";
import { HXAutocomplete } from "./HXAutocomplete";
import { AutocompleteMenuItem } from "./HXAutocomplete.styles";
import { containerWidth, headerAndFooterHeight } from "./AddProject/AddProjectMainView.styles";
const iPhoneScreenWidth = "393px";
const iPhoneScreenHeight = "791px";
export const PatientConsentPreviewContainer = styled(FlexColumn) `
    position: relative;
    flex: 1 0 0;
`;
export const PatientConsentPreviewHeaderContainer = styled(FlexRow) `
    position: fixed;
    box-sizing: border-box;
    min-width: ${containerWidth};
    width: 100%;
    height: ${headerAndFooterHeight};
    padding: 0 80px;
    align-items: center;
    align-self: stretch;
    gap: 48px;
    border-bottom: 1px solid ${colors.black_12};
    background: ${colors.white_background};
`;
export const PatientConsentPreviewConfigurationContainer = styled(FlexRow) `
    flex: 1 0 0;
    align-items: center;
    gap: 16px;
`;
export const PatientConsentPreviewConfigurationAutocomplete = styled(HXAutocomplete).attrs({
    menuWidth: "480px",
    disableClear: true,
    showSelectedValueInOptions: true,
}) `
    width: 200px;
`;
export const PatientConsentPreviewContentContainer = styled(FlexColumn) `
    margin-top: ${headerAndFooterHeight};
    align-items: center;
    flex: 1 0 0;
    overflow-y: auto;
    padding: 24px 0;
`;
export const PatientConsentPreviewContentWrapper = styled(FlexRow) `
    width: ${containerWidth};
    padding: 0 80px;
    gap: 40px;
`;
export const PatientConsentPreviewIPhoneContainer = styled(FlexColumn) `
    flex: 1 1 0;
`;
export const PatientConsentPreviewIPhoneWrapper = styled(FlexColumn) `
    width: ${iPhoneScreenWidth};
    height: ${iPhoneScreenHeight};
    position: relative;
    align-self: flex-end;
`;
export const PatientConsentPreviewIPhoneImage = styled.img.attrs({
    src: IphoneImage,
    width: iPhoneScreenWidth,
    height: iPhoneScreenHeight,
}) `
    width: ${iPhoneScreenWidth};
    height: ${iPhoneScreenHeight};
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    pointer-events: none;
`;
export const PatientConsentPreviewFlowContentContainer = styled.div `
    position: absolute;
    width: 100%;
    height: calc(100% + 2px);
    top: 24px;
    right: 0px;
    z-index: 0;
    transform: scale(0.868);
    background: ${(props) => (props.showLoginGradient ? "linear-gradient(180deg, #FFE09A -52.59%, #FAFAFA 45.84%)" : colors.white_main)};
    overflow-y: auto;
`;
export const PatientConsentPreviewPageDetailsContainer = styled(FlexColumn) `
    width: 400px;
    margin-top: 120px;
`;
export const PatientConsentPreviewPageDetailsWrapper = styled(FlexColumn) `
    width: 400px;
    gap: 24px;
    justify-content: center;
`;
export const PatientConsentPreviewPageDetailsPreviewModeContainer = styled(FlexColumn) `
    width: 400px;
    padding: 8px;
    gap: 4px;
    border-radius: 4px;
    background: ${colors.sunset_8};
    box-sizing: border-box;
`;
export const PatientConsentPreviewPageDetailsOrangeRedEyeIcon = styled(RemoveRedEye) `
    width: 24px;
    height: 24px;
    color: ${colors.sunset_main};
`;
export const PatientConsentPreviewPageDetailsPreviewModeText = styled(LightSmallText) `
    width: 382px;
`;
export const PatientConsentPreviewPageExplanationText = styled(LightText) `
    white-space: pre-line;
`;
export const PreviewMenuItem = styled(AutocompleteMenuItem) ``;
export const PreviewLanguageMenuItem = styled.div `
    flex: 1 0 0;
`;
